export default function MultilineText({ text, separator = /\n/ }) {
    if (!separator.test(text))
        return text

    const lines = text.split(separator)

    return lines.map((line, index) => (
        <React.Fragment key={line}>
            {index > 0 && <br />}
            {line}
        </React.Fragment>
    ))
}
